// User roles texts
export const ROLES_TEXTS = {
  admin: 'Admin',
  user: 'Utilisateur',
  organization_user: 'Utilisateur Organisation',
  locations_user: 'Utilisateur Locations'
} as const;